<template>
  <div class="toptpMfaSetting">
    <account-header />
    <v-divider class="toptpMfaSetting_divider" />
    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
      class="toptpMfaSetting_content"
    >
      <section class="toptpMfaSetting_content-item">
        <span>1.</span>
        <p>スマートフォンに認証アプリをダウンロードします。</p>
      </section>
      <section class="toptpMfaSetting_content-subitem">
        <a
          href="https://www.microsoft.com/ja-jp/security/mobile-authenticator-app"
          target="_blank"
        >
          Microsoft Authenticator
        </a>
      </section>
      <section class="toptpMfaSetting_content-item">
        <span>2.</span>
        <p>認証アプリを起動し、認証アプリ内にアカウントを追加します。</p>
      </section>
      <section class="toptpMfaSetting_content-item">
        <span>3.</span>
        <p>次の画像をスキャンします。</p>
      </section>
      <section class="toptpMfaSetting_qr">
        <qrcode-vue
          :value="qrCodeValue"
          class="toptpMfaSetting_image"
        ></qrcode-vue>
        <section>
          <p>
            画像をスキャン出来ない場合は、アプリケーションに次の情報を入力してください。
          </p>
          <div class="toptpMfaSetting_qr-wrapper">
            <span class="toptpMfaSetting_qr-label">コード <em>:</em></span>
            <span class="toptpMfaSetting_qr-value">{{ manualCode }}</span>
          </div>
        </section>
      </section>
      <section class="toptpMfaSetting_content-item">
        <span>4.</span>
        <p>アプリ内に表示されている、6桁のコードを入力してください。</p>
      </section>
      <section class="toptpMfaSetting_container">
        <ValidationProvider
          v-slot="{ errors }"
          vid="code"
          name="認証コード"
          rules="required"
          class="toptpMfaSetting_input"
        >
          <h4
            class="toptpMfaSetting_container_item"
            :class="{
              ['toptpMfaSetting_container_item--error']: errors.length,
            }"
          >
            認証コード
          </h4>

          <v-text-field
            v-model="code"
            maxlength="6"
            required
            class="toptpMfaSetting_container_input"
            :error-messages="errors"
            color="dark"
            full-width
            placeholder="999999"
            outlined
          />
        </ValidationProvider>
      </section>
      <div class="toptpMfaSetting_action">
        <v-btn
          class="toptpMfaSetting_btn-submit"
          :disabled="invalid"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          セキュリティ設定を保存する
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import AccountHeader from '../AccountHeader.vue';
import QrcodeVue from 'qrcode.vue';
import { authService } from '@/services/auth.service';
import { mapState } from 'vuex';

export default {
  name: 'ToptpMfaSetting',
  components: {
    AccountHeader,
    QrcodeVue,
  },
  data() {
    return {
      submitLoading: false,
      code: '',
      qrCodeValue: '',
      manualCode: '000 222 333',
      url: 'https://mobilexxxxxxxxxxxxxxx/xxxxxx/000000000000/ABC',
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
    }),
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : null;
    },
  },
  watch: {
    userEmail: {
      handler: function (val) {
        if (val) {
          authService.getTOTPCode(val).then((result) => {
            this.qrCodeValue = result.str;
            this.manualCode = result.code;
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    async handleSubmit() {
      try {
        this.submitLoading = true;
        await authService.verifyTOTP(this.code);
        this.$router.push({ name: 'account-mfa' });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.toptpMfaSetting {
  overflow: auto;
  height: 100%;

  &_content {
    display: flex;
    margin-top: 15px;
    justify-content: center;
    flex-direction: column;
    form {
      width: 100%;
      padding: 0 40px;
    }
    &-item {
      display: flex;
      align-items: baseline;
      p,
      span {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      p {
        margin-bottom: 15px;
      }
      span {
        margin-right: 3px;
        font-size: 15px;
      }
    }
    &-subitem {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-bottom: 15px;
      padding-left: 18px;
    }
  }

  &_image {
    width: 123px;
    height: 123px;
  }
  &_qr {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    &-wrapper {
      display: flex;
      margin-bottom: 4px;
      &:last-child {
        margin-bottom: 15px;
      }
    }
    &-label {
      min-width: 70px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &-value {
      line-break: anywhere;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }

    p {
      margin-bottom: 4px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
  }
  &_input {
    margin-top: 4px;
    &-label {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.7px;
      text-align: left;
      color: var(--text-color-2);
      margin-right: 20px;
    }
    &-code {
      &.v-text-field {
        max-width: 168px;
        font-size: 40px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 2px;
        text-align: center;
        color: var(--text-color);
        &.theme--light.v-input input {
          max-width: 168px;
          max-height: 70px;
          text-align: center;
        }
      }
    }
  }
  &_item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin: 10px 0;
  }
  &_container {
    display: flex;
    flex-direction: column;
    &_item {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-bottom: 10px;
      &--error {
        color: var(--v-error-base);
      }
    }
    &_input {
      margin-bottom: 0;
      margin-top: 0;
      padding-top: 0;
      width: 295px;
      &.v-input {
        font-size: 18px;
        .v-messages:not(.error--text) {
          .v-messages__message {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #989898;
          }
        }
      }
      .v-text-field__slot {
        padding-left: 0;
      }
      .v-input__slot {
        min-height: 40px !important;
        .v-message__message {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #989898;
        }
      }
      input {
        line-height: 32px !important;
        color: var(--text-color) !important;
        font-size: 18px !important;
        font-weight: normal !important;
        font-stretch: normal !important;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        &:-webkit-autofill,
        &:-webkit-autofill::first-line {
          font-family: 'Noto Sans JP', sans-serif;
          font-size: 18px;
          font-weight: 500;
        }
      }

      .v-text-field__details {
        padding: 0 !important;
        padding-top: 0px !important;
        margin-bottom: 0 !important;
      }
    }
  }

  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    &-delete {
      padding: 9px 0;
    }
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        height: 36px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }

    &-delete {
      .icon-trash {
        font-size: 16px;
        color: #989898;
      }
    }
  }
}
</style>
